import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import defaultStyles from '../../constants/stylesDefault';
import { WEEK_DAYS } from '../../constants/weekDays';

const styles = () => ({
  listItem: {
    display: 'flex',
  },
  day: {
    width: 100,
  },
  businessHoursSwitch: {
    marginRight: 30,
  },
  timePicker: {
    maxWidth: 150,
    margin: '0px 30px',
  },
  afternoonTime: {
    marginLeft: 40,
    display: 'flex',
  },
});

const THIRTY_MIN = 1800;

export class SiteBusinessHours extends Component {
  static propTypes = {
    businessHours: PropTypes.array.isRequired,
    isOpenAllTime: PropTypes.bool.isRequired,
    onSwitch: PropTypes.func.isRequired,
    onChangeTime: PropTypes.func.isRequired,
    onSwitchIsOpenAllTime: PropTypes.func.isRequired,
  };

  businessHourDay = day => {
    return WEEK_DAYS[day - 1];
  };

  handleSwitch = (event, businessHour, name) => {
    this.props.onSwitch(event, businessHour, name);
  };

  handleChangeTime = (event, businessHour, name) => {
    this.props.onChangeTime(event, businessHour, name);
  };

  handleSwitchIsOpenAllTime = (event) => {
    this.props.onSwitchIsOpenAllTime(event);
  };

  render() {
    const {
      isOpenAllTime,
      businessHours,
      classes,
    } = this.props;

    return (
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Horaires d'ouverture
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={isOpenAllTime}
                onChange={this.handleSwitchIsOpenAllTime}
                name="openAllTime"
                color="primary"
              />
            }
            label="Ouverture 24h/24h"
          />
          {
            !isOpenAllTime &&
            <List>
              {businessHours.map((businessHour) => {
                return (
                  <ListItem className={classes.listItem} key={`bh_item_${businessHour.day}`}>
                    <div className={classes.day}>
                      {this.businessHourDay(businessHour.day)}
                    </div>
                    <FormControlLabel
                      className={classes.businessHoursSwitch}
                      control={
                        <Switch
                          checked={businessHour.is_open}
                          onChange={(e) => this.handleSwitch(e, businessHour, 'is_open')}
                          name="open"
                          color="primary"
                        />
                      }
                      label="Ouvert"
                    />
                    <FormControlLabel
                      className={classes.businessHoursSwitch}
                      control={
                        <Switch
                          checked={businessHour.is_continuous_day}
                          onChange={(e) => this.handleSwitch(e,
                            businessHour,
                            'is_continuous_day',
                          )}
                          name="continuousDay"
                          color="primary"
                        />
                      }
                      label="Journée continue"
                      disabled={!businessHour.is_open}
                    />
                    <Typography
                      variant="body2"
                    >
                      De:
                    </Typography>
                    <TextField
                      className={classes.timePicker}
                      type="time"
                      value={businessHour.morning_start}
                      onChange={(e) => this.handleChangeTime(e, businessHour, 'morning_start')}
                      inputProps={{
                        step: THIRTY_MIN, // 30 min
                      }}
                      disabled={!businessHour.is_open}
                    />
                    <Typography
                      variant="body2"
                    >
                      à:
                    </Typography>
                    <TextField
                      className={classes.timePicker}
                      type="time"
                      value={businessHour.morning_end}
                      onChange={(e) => this.handleChangeTime(e, businessHour, 'morning_end')}
                      inputProps={{
                        step: THIRTY_MIN, // 30 min
                      }}
                      disabled={!businessHour.is_open}
                    />
                    <div className={classes.afternoonTime}>
                      <Typography
                        variant="body2"
                      >
                        et de:
                      </Typography>
                      <TextField
                        className={classes.timePicker}
                        type="time"
                        value={businessHour.afternoon_start}
                        onChange={(e) => this.handleChangeTime(e, businessHour, 'afternoon_start')}
                        inputProps={{
                          step: THIRTY_MIN, // 30 min
                        }}
                        disabled={businessHour.is_continuous_day || !businessHour.is_open}
                      />
                      <Typography
                        variant="body2"
                      >
                        à:
                      </Typography>
                      <TextField
                        className={classes.timePicker}
                        type="time"
                        value={businessHour.afternoon_end}
                        onChange={(e) => this.handleChangeTime(e, businessHour, 'afternoon_end')}
                        inputProps={{
                          step: THIRTY_MIN, // 30 min
                        }}
                        disabled={businessHour.is_continuous_day || !businessHour.is_open}
                      />
                    </div>
                  </ListItem>
                );
              })}
            </List>
          }
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SiteBusinessHours);



// WEBPACK FOOTER //
// ./src/components/Site/SiteBusinessHours.jsx